<template>
    <div class="map-style-changer">
        <b-button
            v-for="style in options"
            :key="style.label"
            size="is-small"
            :type="selected === style.label ? 'is-info' : ''"
            expanded
            class="option"
            @click="$emit('change', style)"
        >
            {{ style.label }}
        </b-button>
    </div>
</template>

<script>
export default {
    name: 'MapStyleChanger',

    props: {
        options: {
            type: Array,
            required: true,
        },

        selected: {
            type: String,
            required: true,
        },
    },
};
</script>

<style lang="scss">
.map-style-changer {
    position: absolute;
    right: 10px;
    bottom: 100px;
    display: flex;
    flex-direction: row;

    .option {
        font-size: 0.8rem;
        border-radius: 0 !important;

        &:first-child {
            border-top-left-radius: 5px !important;
            border-bottom-left-radius: 5px !important;
        }

        &:last-child {
            border-top-right-radius: 5px !important;
            border-bottom-right-radius: 5px !important;
        }
    }
}
</style>
